export const regTypes = {
  ALL: 'all',
  PERSONAL_INFO: 'personalInfo',
  CONTRACT: 'contract',
  FORM_6101: 'form6101',
  FORM_101: 'form101'
};
